const RequestType = {
	All: {
		key: 'All',
		text: 'All',
		doShowIfZero: true,
	},
	ReadyToDownload: {
		key: 'ReadyToDownload',
		text: 'Ready to Download',
	},
	DownloadedNotReviewed: {
		key: 'DownloadedNotReviewed',
		text: 'Downloaded, Not Reviewed',
	},
	DownloadedReviewed: {
		key: 'DownloadedReviewed',
		text: 'Downloaded, Reviewed',
	},
	Declined: {
		key: 'Declined',
		text: 'Declined',
	},
	Pending: {
		key: 'Pending',
		text: 'Pending',
	},
};

export default RequestType;
